import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import VehicleInfo from "./Platinum/VehicleInfo";
import VehicleOtherDetails from "./Platinum/VehicleOtherDetails";
import VimSummary from "./Platinum/VinSummary";
import VehiclePhotos from "./Platinum/VehiclePhotos";

class VehicleDetails extends Component {
  state = {
    activeIndex: 0,
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Accordion fluid styled id={`acc_row_${this.props.detailIndex}`}>
        <Accordion.Title
          active={this.state.activeIndex === 0}
          key={`veh_details_title_${this.props.detailIndex}`}
          onClick={() => this.handleClick()}
          className={"report-name-header"}
        >
          <p>
            {_.get(this.props.record, "vehicleInfo[0].yearMake[0]._")}&#160;
            {_.get(this.props.record, "vehicleInfo[0].make[0]._")}&#160;
            {_.get(this.props.record, "vehicleInfo[0].model[0]._")}
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`veh_details_body_${this.props.detailIndex}`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  <VehicleInfo {...this.props} />
                </Table.Cell>
              </Table.Row>
              {(_.get(this.props.record, "registrants[0].registrant[0]") ||
                _.get(this.props.record, "owners[0].owner") ||
                _.get(this.props.record, "lienHolders[0].lienHolder") ||
                _.get(this.props.record, "lessees[0].lessee") ||
                _.get(this.props.record, "lessors[0].lessor")) && (
                <Table.Row>
                  <Table.Cell>
                    <VehicleOtherDetails {...this.props} />
                  </Table.Cell>
                </Table.Row>
              )}
              <Table.Row>
                <Table.Cell>
                  <VimSummary {...this.props} />
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <VehiclePhotos {...this.props} />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default VehicleDetails;



// WEBPACK FOOTER //
// ./src/components/reports/VehicleDetails.js